module.exports = __webpack_public_path__ + "img/1_m.96204de0.jpg";